export default __webpack_public_path__ + "static/media/jbc.8fa9668f.jpg";